var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "70", height: "70", viewBox: "0 0 70 70", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "cue/file.inline"
    ),
    React.createElement("path", { d: "M58.27 37.028l11.851 11.85-4.242 4.243L59 46.243V70h-6V46.243l-6.879 6.878-4.242-4.242 12-12c1.33-1.331 3.327-1.061 4.391.149zM33.5 5.102V26.5H11v38.398h36v5H9a3 3 0 0 1-3-3v-44.89a2 2 0 0 1 .62-1.448L27.524.654a2 2 0 0 1 1.379-.552H60a3 3 0 0 1 3 3V30h-5V5.102H33.5zm-5 1.526L12.884 21.5H28.5V6.628z", fill: "#FFF", fillRule: "nonzero" })
  );
});